// Constants for bulk upload operations
export const FILE_UPLOAD_LIMITS = {
	MAX_FILES: 25000,
	CHUNK_SIZE: 500,
	S3_UPLOAD_CHUNK_SIZE: 4,
};

export const IGNORED_FILENAMES = [".ds_store", "desktop.ini", "thumbs.db"];

export const ERROR_CODES = {
	DUPLICATE_WITH_SPECIAL_CHARS: 6502,
	SPECIAL_CHARS_ONLY: 6501,
	DUPLICATE_ONLY: 6500,
};
